export default "__VITE_ASSET__BHrI1L_C__"